import { useState, useEffect } from "react";
import { getAllProperties } from "services";
import { FeaturedPropertiesSliderComponent } from "./FeaturedPropertiesSliderComponent";
import "../../../node_modules/@reusejs/react/dist/vendors/swiper.css";
import FeaturedPropertyDetailWithImage from "./FeaturedPropertyDetailCardWithImage";

const supportLinks = [
  {
    name: "Auction Bazaar Verified",
    href: "#",
    description:
      "We physically, legally, and technically verify all the images and documents related to a property.",
  },
  {
    name: "Exclusive properties",
    href: "#",
    description:
      "Dedicated properties from a financial institution will be listed.",
  },
  {
    name: "Expert choice",
    href: "#",
    description:
      "We recommend customized properties suitable to the user's preferences.",
  },
];

export default function FeaturedPropertiesComponent() {
  const [propertiesData, setPropertiesData] = useState([]);
  const getProperties = async () => {
    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: ["city", "sub_asset_type", "bank", "images"],
        includeMutations: ["state", "asset"],
        includeFacets: false,
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        { attribute: "featured", op: "eq", value: "true" },
        {
          attribute: "status",
          op: "eq",
          value: "active",
        },
      ],
    });
    setPropertiesData(data.data);
  };

  useEffect(() => {
    getProperties();
  }, []);

  return (
    <div className="bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto py-20 px-4 sm:px-6 lg:px-8">
        <h3 className="text-2xl md:text-3xl text-center font-extrabold text-white sm:text-3xl sm:leading-none sm:tracking-tight lg:text-4xl">
          Featured Properties
        </h3>
        <p className="mt-4 text-center text-sm md:text-base text-white">
          Bank-promoted properties auctioned on our website.
        </p>
        <div className="mt-16 mb-2 xl:-mx-32 relative">
          <div className="backdrop-blur-sm bg-gradient-to-r from-black z-9 absolute top-0 left-0 w-1/12 lg:w-1/5 rounded-r  h-full opacity-90" />
          <div className="backdrop-blur-sm bg-gradient-to-l from-black z-9 absolute top-0 right-0 w-1/12 lg:w-1/5 rounded-l  h-full opacity-90" />
          {/* mobile view */}
          <div className="block lg:hidden">
            <FeaturedPropertiesSliderComponent
              elements={
                propertiesData &&
                propertiesData.map((item: any, index) => (
                  <FeaturedPropertyDetailWithImage
                    top={true}
                    widthClass="w-72"
                    marginClass="mx-10"
                    width={384}
                    // height={482}
                    height={160}
                    onClick={() => console.log("Card action button clicked")}
                    property={item}
                    {...item}
                    key={index}
                  />
                ))
              }
            />
          </div>
          {/*Tablet/Desktop view */}
          <div className="hidden lg:block">
            <FeaturedPropertiesSliderComponent
              elements={
                propertiesData &&
                propertiesData.map((item: any, index) => (
                  <FeaturedPropertyDetailWithImage
                    top={false}
                    widthClass="w-96"
                    marginClass="mx-0"
                    width={384}
                    height={482}
                    onClick={() => console.log("Card action button clicked")}
                    property={item}
                    {...item}
                    key={index}
                  />
                ))
              }
            />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-4">
          {supportLinks.map((item) => (
            <div key={item.name} className="flex text-center flex-col mt-12">
              <div className="flex-1 relative px-6 pb-4">
                <h4 className="text-lg md:text-xl font-medium text-white">
                  {item.name}
                </h4>
                <p className="mt-4 text-sm md:text-base text-gray-400">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
